import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'ui-content-empty',
  host: { 'class': 'content-empty' },
  encapsulation: ViewEncapsulation.None,
  templateUrl: './content-empty.html',
  styleUrls: ['./content-empty.scss']
})
export class UIContentEmpty {
  @Input()
  text: string = 'Sin registros';
}